module.exports = __webpack_public_path__ + "images/frontpage@3x.png?9472c34d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage@3x.png
// module id = 626
// module chunks = 7